import React, { useEffect, useState } from 'react';

import classes from "../SitesOnSchedule/sitesOnScheduleSearchBar.module.css"
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png'
import sort from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sorting.png'

import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ListBox } from 'primereact/listbox';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import DataManager from '../../hooks/DataManager';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { serviceActions } from '../../store/service-Slice';
import { useDispatch, useSelector } from 'react-redux';

const AllSitesSearchBar = (props) => {
  const {
    placeholder,
    onChange,
    value,
    handleFocus,
    handleBlur,
    showFilterButton,
    groups,
    includeSubgroups,
    setIncludeSubgroups,
    online,
    setOnline,
    offline,
    setOffline,
    deviceTag,
    setDeviceTag,
    cloudController,
    setCloudController,
    davantis,
    setDavantis,
    G2CC,
    setG2CC,
    ESP,
    setESP,
    RPi,
    setRPi,
    groupName,
    setGroupName,
    submit,
    setSubmit,
    noTag,
    setNoTag,
    isControllers,
    setUserCountDesc,
    noUsers,
    setNoUsers,
    liveViewStatus,
    setLiveViewStatus,
    scheduleOnly, 
    setScheduleOnly,
    hasAjax,
    setHasAjax,
    hasHik,
    setHasHik,
    hasAIBOX,
    setHasAIBOX,
    hasDahua,
    setHasDahua,
    active,
    setActive,
    hasPadlock,
    setHasPadlock,
    hasKeybox,
    setHasKeybox,
    hasGateway,
    setHasGateway,
    hasSigfox,
    setHasSigfox,
    hasIndSigfox,
    setHasIndSigfox,
    hasEfento,
    setHasEfento,
    hasTeltonika, 
    setHasTeltonika,
    hasSchedule,
    setHasSchedule,
    hasTempSchedules,
    setHasTempSchedules,
    activePinCount,
    setActivePinCount,
    sortAsc,
    setSortAsc,
    sUserCount,
    setSUserCount,
    sCreated,
    setSCreated,
    sFirmware,
    setSFirmware,
    sName,
    setSName,
    sCameraCount,
    setSCameraCount,
    isGroupSites,
    ruleV2Owner, 
    setRuleV2Owner, 
    ruleV2Parent, 
    setRuleV2Parent, 
    ruleV2Affected, 
    setRuleV2Affected,
    connectionIssues,
    setConnectionIssues,
    hasCamerasLinked,
    setHasCamerasLinked,
    isInitialLoading, 
    setIsInitialLoading
  } = props;


  const [showFilters, setShowFilters] = useState(false);
  const [showSorts, setShowSorts] = useState(false);

  const dispatch = useDispatch();
  const service = useSelector(state => state.service);

  const [localOnline, setLocalOnline] = useState(online);
  const [localOffline, setLocalOffline] = useState(offline);
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localIncludeSubgroups, setLocalIncludesSubgroups] = useState(includeSubgroups)
  const [localNoTag, setLocalNoTag] = useState(noTag);
  const [localIncludes, setLocalIncludes] = useState("")
  const [localExcludes, setLocalExcludes] = useState("")
  const [localActive, setLocalActive] = useState(active)
  const [localNoUsers, setLocalNoUsers] = useState(noUsers)
  const [localLiveViewStatus, setLocalLiveViewStatus] = useState(liveViewStatus)
  const [localScheduleOnly, setLocalScheduleOnly] = useState(scheduleOnly)
  const [localHasAjax, setLocalHasAjax] = useState(hasAjax)
  const [localHasHik, setLocalHasHik] = useState(hasHik)
  const [localHasAIBOX, setLocalHasAIBOX] = useState(hasAIBOX)
  const [localHasDahua, setLocalHasDahua] = useState(hasDahua)
  const [localHasPadlock, setLocalHasPadlock] = useState(hasPadlock)
  const [localHasKeybox, setLocalHasKeybox] = useState(hasKeybox)
  const [localHasGateway, setLocalHasGateway] = useState(hasGateway)
  const [localHasSigfox, setLocalHasSigfox] = useState(hasSigfox)
  const [localHasIndSigfox, setLocalHasIndSigfox] = useState(hasIndSigfox)
  const [localHasEfento, setLocalHasEfento] = useState(hasEfento)
  const [localHasTeltonika, setLocalHasTeltonika] = useState(hasTeltonika)
  const [localHasSchedule, setLocalHasSchedule] = useState(hasSchedule)
  const [localHasTempSchedule, setLocalHasTempSchedule] = useState(hasTempSchedules)
  const [localActivePinCount, setLocalActivePinCount] = useState(activePinCount)

  const [connectedCCTVFilters, setConnectedCCTVFilters] = useState([])
  const [connectedBLEFilters, setConnectedBLEFilters] = useState([])
  const [connectedSensorFilters, setConnectedSensorFilters] = useState([])

  const [siteStatusFilters, setSiteStatusFilters] = useState([])
  const [activeStatusFilters, setActiveStatusFilters] = useState([])
  const [siteTypeFilters, setSiteTypeFilters] = useState([])

  const [hasFilters, setHasFilters] = useState(service.hasFilters)
  const [localSortAsc, setLocalSortAsc] = useState(sortAsc)
  const [localSUserCount, setLocalSUserCount] = useState(sUserCount)
  const [localSCreated, setLocalSCreated] = useState(sCreated)
  const [localSFirmware, setLocalSFirmware] = useState(sFirmware)
  const [localSName, setLocalSName] = useState(sName)
  const [localSCameraCount, setLocalSCameraCount] = useState(sCameraCount)

  const [localRuleV2Owner, setLocalRuleV2Owner] = useState(ruleV2Owner)
  const [localRuleV2Parent, setLocalRuleV2Parent] = useState(ruleV2Parent)
  const [localRuleV2Affected, setLocalRuleV2Affected] = useState(ruleV2Affected)

  const [localConnectionIssues, setLocalConnectionIssues] = useState(connectionIssues)
  const [localHasCamerasLinked, setLocalHasCamerasLinked] = useState(hasCamerasLinked)

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const handleClear = () => {
    onChange({ target: { value: '' } });
  };

  const handleShowFilters = () => {
    setShowFilters(prev => !prev);
    setShowSorts(false)
  };

  const handleShowSorts = () => {
    setShowSorts(prev => !prev);
    setShowFilters(false)
  };

  useEffect(() => {
    setLocalOnline(online)
    setLocalOffline(offline)
    setLocalDeviceTag(deviceTag)
    setLocalGroupName(groupName)
    setLocalIncludesSubgroups(includeSubgroups)
    setLocalNoTag(noTag)
    setLocalNoUsers(noUsers)
    setLocalLiveViewStatus(liveViewStatus)
    setLocalScheduleOnly(scheduleOnly)
    setLocalHasAjax(hasAjax)
    setLocalHasHik(hasHik)
    setLocalHasAIBOX(hasAIBOX)
    setLocalHasDahua(hasDahua)
    setLocalHasPadlock(hasPadlock)
    setLocalHasKeybox(hasKeybox)
    setLocalHasGateway(hasGateway)
    setLocalHasSigfox(hasSigfox)
    setLocalHasIndSigfox(hasIndSigfox)
    setLocalHasEfento(hasEfento)
    setLocalHasTeltonika(hasTeltonika)
    setLocalHasSchedule(hasSchedule)
    setLocalHasTempSchedule(hasTempSchedules)
    setLocalActivePinCount(activePinCount)
    setLocalActive(active)
    setLocalSortAsc(sortAsc)
    setLocalSUserCount(sUserCount)
    setLocalSCreated(sCreated)
    setLocalSFirmware(sFirmware)
    setLocalSName(sName)
    setLocalSCameraCount(sCameraCount)
    setLocalRuleV2Owner(ruleV2Owner)
    setLocalRuleV2Parent(ruleV2Parent)
    setLocalRuleV2Affected(ruleV2Affected)
    setLocalConnectionIssues(connectionIssues)
    setLocalHasCamerasLinked(hasCamerasLinked)

    setConnectedCCTVFilters(
      hasAjax || hasDahua || hasHik || hasAIBOX ? ['AJAX', 'Dahua', 'Hikvision', 'Ganz AIBOX'].filter(f => {
        return (f == "AJAX" && hasAjax) || (f == "Dahua" && hasDahua) || (f == "Hikvision" && hasHik) || (f == "Ganz AIBOX" && hasAIBOX)
      }) : []
    )
    setConnectedBLEFilters(
      hasPadlock || hasKeybox || hasGateway ? ['Smart padlock', 'Keybox', 'Gateway'].filter(f => {
        return (f === 'Smart padlock' && hasPadlock) || (f === 'Keybox' && hasKeybox) || (f === 'Gateway' && hasGateway)
      }) : []
    )
    setConnectedSensorFilters(
      hasSigfox || hasIndSigfox || hasEfento || hasTeltonika ? ['Sigfox lite contact', 'Sigfox industrial contact', 'NB-IOT contact', 'BLE Sensor'].filter(f => {
        return (f === 'Sigfox lite contact' && hasSigfox) || (f === 'Sigfox industrial contact' && hasIndSigfox) || (f === 'NB-IOT contact' && hasEfento) || (f === 'BLE Sensor' && hasTeltonika)
      }) : []
    )
    setSiteStatusFilters(
      online ? ['Online'] : []
    )
    setActiveStatusFilters(
      active === 1 ? ['Active'] : active === 0 ? ['Inactive'] : []
    )
    setSiteTypeFilters(
      cloudController || davantis || G2CC || ESP || RPi
        ? [
          ...(cloudController ? ['Cloud controllers (CC)'] : []),
          ...(davantis ? ['Davantis CC'] : []),
          ...(G2CC ? ['G2CC'] : []),
          ...(ESP ? ['Physical - ESP'] : []),
          ...(RPi ? ['Physical - RPi'] : [])
        ]
        : []
    )
  }, [
    online,
    offline,
    deviceTag,
    groupName,
    includeSubgroups,
    noTag,
    noUsers,
    liveViewStatus,
    scheduleOnly,
    hasAjax,
    hasHik,
    hasAIBOX,
    hasDahua,
    hasPadlock,
    hasKeybox,
    hasGateway,
    hasSigfox,
    hasIndSigfox,
    hasEfento,
    hasTeltonika,
    hasSchedule,
    hasTempSchedules,
    activePinCount,
    active,
    sortAsc,
    sUserCount,
    sCreated,
    sFirmware,
    sName,
    sCameraCount,
    cloudController,
    davantis,
    G2CC,
    ESP,
    RPi,
    ruleV2Owner, 
    ruleV2Parent,
    ruleV2Affected,
    connectionIssues,
    hasCamerasLinked
  ])

  const filterDefaults = {
    active: -1,
    online: 0,
    offline: 0,
    deviceTag: null,
    cloudController: 0,
    davantis: 0,
    g2cc: 0,
    ESP: 0,
    RPi: 0,
    groupName: null,
    includeSubgroups: 0,
    noTag: 0,
    searchTerm: null,
    noUsers: 0,
    liveViewStatus: -1,
    scheduleOnly: -1,
    hasAjax: 0,
    hasHik: 0,
    hasAIBOX: 0,
    hasDahua: 0,
    hasPadlock: 0,
    hasKeybox: 0,
    hasGateway: 0,
    hasSigfox: 0,
    hasIndSigfox: 0,
    hasEfento: 0,
    hasTeltonika: 0,
    hasSchedules: 0,
    hasTempSchedules: 0,
    activePinCount: -1,
    sortAsc: 0,
    sUserCount: 0,
    sCreated: 1,
    sFirmware: 0,
    sName: 0,
    sCameraCount: 0,
    ruleV2Owner: 0,
    ruleV2Parent: 0,
    ruleV2Affected: 0,
    connectionIssues: 0,
    hasCamerasLinked: -1
  };

  const setters = {
    online: setOnline,
    offline: setOffline,
    deviceTag: setDeviceTag,
    cloudController: setCloudController,
    davantis: setDavantis,
    g2cc: setG2CC,
    ESP: setESP,
    RPi: setRPi,
    groupName: setGroupName,
    includeSubgroups: setIncludeSubgroups,
    noTag: setNoTag,
    noUsers: setNoUsers,
    liveViewStatus: setLiveViewStatus,
    scheduleOnly: setScheduleOnly,
    hasAjax: setHasAjax,
    hasHik: setHasHik,
    hasAIBOX: setHasAIBOX,
    hasDahua: setHasDahua,
    hasPadlock: setHasPadlock,
    hasKeybox: setHasKeybox,
    hasGateway: setHasGateway,
    hasSigfox: setHasSigfox,
    hasIndSigfox: setHasIndSigfox,
    hasEfento: setHasEfento,
    hasTeltonika: setHasTeltonika,
    hasSchedules: setHasSchedule,
    hasTempSchedules: setHasTempSchedules,
    activePinCount: setActivePinCount,
    sortAsc: setSortAsc,
    sUserCount: setSUserCount,
    sCreated: setSCreated,
    sFirmware: setSFirmware,
    sName: setSName,
    sCameraCount: setSCameraCount,
    active: setActive,
    ruleV2Owner: setRuleV2Owner,
    ruleV2Parent: setRuleV2Parent,
    ruleV2Affected: setRuleV2Affected,
    connectionIssues: setConnectionIssues,
    hasCamerasLinked: setHasCamerasLinked
  }

  const HandleResetFilters = () => {
    setLocalOnline(0)
    setLocalOffline(0)
    setLocalDeviceTag(null)
    setLocalGroupName(null)
    setLocalIncludesSubgroups(0)
    setLocalNoTag(0)
    setLocalNoUsers(0)
    setLocalLiveViewStatus(-1)
    setLocalScheduleOnly(-1)
    setLocalHasAjax(0)
    setLocalHasHik(0)
    setLocalHasAIBOX(0)
    setLocalHasDahua(0)
    setLocalActive(-1)
    setLocalHasPadlock(0)
    setLocalHasKeybox(0)
    setLocalHasGateway(0)
    setLocalHasSigfox(0)
    setLocalHasIndSigfox(0)
    setLocalHasEfento(0)
    setLocalHasTeltonika(0)
    setLocalHasSchedule(0)
    setLocalHasTempSchedule(0)
    setLocalActivePinCount(-1)
    setSUserCount(0)
    setSCreated(1)
    setSFirmware(0)
    setSName(0)
    setSCameraCount(0)
    setLocalRuleV2Owner(0)
    setLocalRuleV2Parent(0)
    setLocalRuleV2Affected(0)
    setLocalConnectionIssues(0)
    setLocalHasCamerasLinked(-1)

    Object.entries(setters).forEach(([key, setter]) => {
      setter(filterDefaults[key])
    });

    dispatch(serviceActions.resetFilters(filterDefaults));
    dispatch(serviceActions.setHasFilters(false));

    //setSubmit(submit + 1)
    setHasFilters(false)
    setShowFilters(false)
  }

  const HandleApplyFilters = () => {
    setHasFilters(true)
    const payload = {
      online: siteStatusFilters.includes("Online") ? 1 : 0,
      offline: siteStatusFilters.includes("Offline") ? 1 : 0,
      deviceTag: localDeviceTag,
      cloudController: siteTypeFilters.includes("Cloud controllers (CC)") ? 1 : 0,
      davantis: siteTypeFilters.includes("Davantis CC") ? 1 : 0,
      g2cc: siteTypeFilters.includes("G2CC") ? 1 : 0,
      ESP: siteTypeFilters.includes("Physical - ESP") ? 1 : 0,
      RPi: siteTypeFilters.includes("Physical - RPi") ? 1 : 0,
      groupName: localGroupName,
      includeSubgroups: localIncludeSubgroups,
      noTag: localNoTag,
      noUsers: localNoUsers,
      liveViewStatus: localLiveViewStatus,
      scheduleOnly: localScheduleOnly,
      hasAjax: connectedCCTVFilters.includes("AJAX") ? 1 : 0,
      hasHik: connectedCCTVFilters.includes("Hikvision") ? 1 : 0,
      hasAIBOX: connectedCCTVFilters.includes("Ganz AIBOX") ? 1 : 0,
      hasDahua: connectedCCTVFilters.includes("Dahua") ? 1 : 0,
      hasPadlock: connectedBLEFilters.includes("Smart padlock") ? 1 : 0,
      hasKeybox: connectedBLEFilters.includes("Keybox") ? 1 : 0,
      hasGateway: connectedBLEFilters.includes("Gateway") ? 1 : 0,
      hasSigfox: connectedSensorFilters.includes("Sigfox lite contact") ? 1 : 0,
      hasIndSigfox: connectedSensorFilters.includes("Sigfox industrial contact") ? 1 : 0,
      hasEfento: connectedSensorFilters.includes("NB-IOT contact") ? 1 : 0,
      hasTeltonika: connectedSensorFilters.includes("BLE Sensor") ? 1 : 0,
      hasSchedules: localHasSchedule,
      hasTempSchedules: localHasTempSchedule,
      activePinCount: localActivePinCount,
      sortAsc: localSortAsc,
      sUserCount: localSUserCount,
      sCreated: localSCreated,
      sFirmware: localSFirmware,
      sName: localSName,
      sCameraCount: localSCameraCount,
      ruleV2Owner: localRuleV2Owner,
      ruleV2Parent: localRuleV2Parent,
      ruleV2Affected: localRuleV2Affected,
      connectionIssues: localConnectionIssues,
      hasCamerasLinked: localHasCamerasLinked,
      active: activeStatusFilters.includes("Active")
        ? 1
        : activeStatusFilters.includes("Inactive")
          ? 0
          : -1
    }

    Object.entries(payload).forEach(([key, val]) => {
      setters[key]?.(val)
    })

    dispatch(serviceActions.updateFilters(payload));
    dispatch(serviceActions.setHasFilters(true));

    setShowFilters(false)
    setShowSorts(false)
    //setSubmit(submit + 1)    
  }

  const handleInputChange = (e) => {
    setLocalDeviceTag(e.target.value); // For debugging
  };

  const handleNoPortalName = () => {
    setLocalNoTag(localNoTag == 0 ? 1 : 0)
  }

  const handleHasSchedules = (value) => {
    setLocalHasSchedule(value)
  }

  const handleHasTempSchedules = (value) => {
    setLocalHasTempSchedule(value)
  }

  let connectedCCTVOptions = [
    { label: "AJAX", value: "AJAX" },
    { label: "Dahua", value: "Dahua" },
    { label: "Ganz AIBOX", value: "Ganz AIBOX" },
    { label: "Hikvision", value: "Hikvision" }
  ]

  let connectedBLEOptions = [
    { label: "Smart padlock", value: "Smart padlock" },
    { label: "Keybox", value: "Keybox" },
    { label: "Gateway", value: "Gateway" }
  ]

  let connectedSensorOptions = [
    { label: "Sigfox lite contact", value: "Sigfox lite contact" },
    { label: "Sigfox industrial contact", value: "Sigfox industrial contact" },
    { label: "NB-IOT contact", value: "NB-IOT contact" },
    { label: "BLE Sensor", value: "BLE Sensor" }
  ]

  const siteStatusOptions = [
    { label: "All", value: "All" },
    { label: "Online", value: "Online" },
    { label: "Offline", value: "Offline" }
  ];

  const siteTypeOptions = [
    { label: "All", value: "All" },
    { label: "Cloud controllers (CC)", value: "Cloud controllers (CC)" },
    { label: "Davantis CC", value: "Davantis CC" },
    { label: "G2CC", value: "G2CC" },
    { label: "Physical - ESP", value: "Physical - ESP" },
    { label: "Physical - RPi", value: "Physical - RPi" }
  ]

  const activeStatusOptions = [
    { label: "All", value: "All" },
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" }
  ]

  const activePinCountOptions = [
    { label: "0 active switches", value: 0 },
    { label: "1 active switch", value: 1 },
    { label: "2 active switches", value: 2 },
    { label: "3 active switches", value: 3 },
    { label: "4 active switches", value: 4 },
    { label: "5 active switches", value: 5 },
    { label: "6 active switches", value: 6 },
    { label: "7 active switches", value: 7 },
    { label: "8 active switches", value: 8 }
  ]

  const HandleOrderByUserCount = () => {
    setLocalSUserCount(localSUserCount == 0 ? 1 : 0)
    setLocalSCreated(0)
    setLocalSFirmware(0)
    setLocalSName(0)
    setLocalSCameraCount(0)
  }

  const HandleOrderByCreated = () => {
    setLocalSUserCount(0)
    setLocalSCreated(localSCreated == 0 ? 1 : 0)
    setLocalSFirmware(0)
    setLocalSName(0)
    setLocalSCameraCount(0)
  }

  const HandleOrderByFirmware = () => {
    setLocalSUserCount(0)
    setLocalSCreated(0)
    setLocalSFirmware(localSFirmware == 0 ? 1 : 0)
    setLocalSName(0)
    setLocalSCameraCount(0)
  }

  const HandleOrderByName = () => {
    setLocalSUserCount(0)
    setLocalSCreated(0)
    setLocalSFirmware(0)
    setLocalSName(localSName == 0 ? 1 : 0)
    setLocalSCameraCount(0)
  }

  const HandleOrderByCameraCount = () => {
    setLocalSUserCount(0)
    setLocalSCreated(0)
    setLocalSFirmware(0)
    setLocalSName(0)
    setLocalSCameraCount(localSCameraCount == 0 ? 1 : 0)
  }

  return (
    <>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onKeyPress={handleKeyPress}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          spellCheck={false}
        />


        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">
              ×
            </button>
          )}

          {showFilterButton && <button className={classes.filterButton} onClick={handleShowFilters} type="button">
            <img style={{ height: '30px', width: '30px' }} src={filters} />
          </button>}
          {showFilterButton && <button className={classes.filterButton} onClick={handleShowSorts} type="button">
            <img style={{ height: '30px', width: '30px' }} src={sort} />
          </button>}
        </div>


        {showFilters && (
          <div className={classes.filterDropdown}>
            <div className={classes.buttonRow}>
              <Button  icon="pi pi-refresh" type="button" style={{ marginRight: "15px" }} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger' />
              <Button  icon="pi pi-check" type="button" label="Apply" onClick={HandleApplyFilters} />
            </div>

            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Site status:</label>

              <MultiSelect
                value={siteStatusFilters}
                options={siteStatusOptions}
                onChange={(e) => setSiteStatusFilters(e.value)}
                placeholder="Choose status"
                style={{ width: "400px" }}
              />
            </div>

            <Divider type="solid" style={{ padding: 0 }} />

            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Active status:</label>

              <MultiSelect
                value={activeStatusFilters}
                options={activeStatusOptions}
                style={{ width: '400px' }}
                onChange={(e) => setActiveStatusFilters(e.value)}
                placeholder="Choose active/inactive"
              />
            </div>
            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>No. of active switches:</label>
              <Dropdown
                value={localActivePinCount}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setLocalActivePinCount(e.value)}
                options={activePinCountOptions}
                placeholder="Choose number of switches"
              />
            </div>
            {!isGroupSites &&
              <>
                <Divider type="solid" style={{ padding: 0 }} />
                <div className={classes.filterRow2}>
                  <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Group:</label>
                  <Dropdown
                    value={localGroupName}
                    className="w-full md:w-14rem"
                    style={{ width: '400px' }}
                    onChange={(e) => setLocalGroupName(e.value)}
                    options={groups.map(g => g.name).sort((a, b) => a.localeCompare(b))}
                    placeholder="Choose group"
                    filter
                    filterPlaceholder="Search groups..."
                  />
                </div>
                <div className="flex align-items-center" style={{ marginTop: "10px" }}>
                  <Checkbox name="subgroupEnabled" value="setLocalSubgroup" onChange={() => setLocalIncludesSubgroups(localIncludeSubgroups == 1 ? 0 : 1)} checked={localIncludeSubgroups == 1} />
                  <label style={{ marginLeft: "5px" }} htmlFor="subgroupEnabled" className="ml-2">Include all subgroups</label>
                </div>
              </>}
            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Connected CCTV systems:</label>
              <MultiSelect
                value={connectedCCTVFilters}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setConnectedCCTVFilters(e.value)}
                options={connectedCCTVOptions}
                placeholder="Choose CCTV device"
                filter
                filterPlaceholder="Search device types..."
              />
              <div className="flex align-items-center" style={{ marginTop: "10px" }}>
                <Checkbox name="lvEnabled" value="setConnectionIssues" onChange={() => setLocalConnectionIssues(localConnectionIssues == 1 ? 0 : 1)} checked={localConnectionIssues == 1} />
                <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Only show CCTV systems with connection issues</label>
              </div>

            </div>
            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Connected BLE devices:</label>
              <MultiSelect
                value={connectedBLEFilters}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setConnectedBLEFilters(e.value)}
                options={connectedBLEOptions}
                placeholder="Choose BLE device"
                filter
                filterPlaceholder="Search BLE devices..."
              />
            </div>
            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Connected sensors:</label>
              <MultiSelect
                value={connectedSensorFilters}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setConnectedSensorFilters(e.value)}
                options={connectedSensorOptions}
                placeholder="Choose sensor"
                filter
                filterPlaceholder="Search sensors..."
              />
            </div>
            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.filterRow2}>
              <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Site type:</label>
              <MultiSelect
                value={siteTypeFilters}
                className="w-full md:w-14rem"
                style={{ width: '400px' }}
                onChange={(e) => setSiteTypeFilters(e.value)}
                options={siteTypeOptions}
                placeholder="Choose site type"
              />
            </div>
            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="lvEnabled" value="setLocalDeviceTag" onChange={() => setLocalLiveViewStatus(localLiveViewStatus == 1 ? -1 : 1)} checked={localLiveViewStatus == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Live view enabled</label>
            </div>
            { localLiveViewStatus == 1 && 
            <>
              <div className="flex align-items-center" style={{ marginBottom: "10px", marginLeft:"20px" }}>
                <Checkbox name="lvEnabled" value="setLocalHasCamerasLinked" onChange={() => setLocalHasCamerasLinked(localHasCamerasLinked == 1 ? -1 : 1)} checked={localHasCamerasLinked == 1} />
                <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">With cameras linked</label>
              </div>
              <div className="flex align-items-center" style={{ marginBottom: "10px", marginLeft:"20px" }}>
                <Checkbox name="lvEnabled" value="setLocalHasNoCamerasLinked" onChange={() => setLocalHasCamerasLinked(localHasCamerasLinked == 0 ? -1 : 0)} checked={localHasCamerasLinked == 0} />
                <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Without cameras linked</label>
              </div>
            </>
            }
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="lvDisabled" value="setLocalDeviceTag" onChange={() => setLocalLiveViewStatus(localLiveViewStatus == 0 ? -1 : 0)} checked={localLiveViewStatus == 0} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Live view disabled</label>
            </div>
            { localLiveViewStatus == 0 && 
            <>
             <div className="flex align-items-center" style={{ marginBottom: "10px", marginLeft:"20px" }}>
                <Checkbox name="lvEnabled" value="setLocalHasCamerasLinked" onChange={() => setLocalHasCamerasLinked(localHasCamerasLinked == 1 ? -1 : 1)} checked={localHasCamerasLinked == 1} />
                <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">With cameras linked</label>
              </div>
              <div className="flex align-items-center" style={{ marginBottom: "10px", marginLeft:"20px" }}>
                <Checkbox name="lvEnabled" value="setLocalHasNoCamerasLinked" onChange={() => setLocalHasCamerasLinked(localHasCamerasLinked == 0 ? -1 : 0)} checked={localHasCamerasLinked == 0} />
                <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Without cameras linked</label>
              </div>
              </>
            }
            
            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="lvEnabled" value="setLocalDeviceTag" onChange={() => setLocalScheduleOnly(localScheduleOnly == 1 ? -1 : 1)} checked={localScheduleOnly == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Schedule only enabled</label>
            </div>
            <div className="flex align-items-center">
              <Checkbox name="lvDisabled" value="setLocalDeviceTag" onChange={() => setLocalScheduleOnly(localScheduleOnly == 0 ? -1 : 0)} checked={localScheduleOnly == 0} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Schedule only disabled</label>
            </div>

            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="rulev2Owner" value="setLocalRuleV2Owner" onChange={() => setLocalRuleV2Owner(localRuleV2Owner == 0 ? 1 : 0)} checked={localRuleV2Owner == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Has a rule</label>
            </div>
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="ruleV2Parent" value="setLocalV2Parent" onChange={() => setLocalRuleV2Parent(localRuleV2Parent == 0 ? 1 : 0)} checked={localRuleV2Parent == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Is a parent site</label>
            </div>
            <div className="flex align-items-center">
              <Checkbox name="ruleV2Affected" value="setLocalRuleV2Affected" onChange={() => setLocalRuleV2Affected(localRuleV2Affected == 0 ? 1 : 0)} checked={localRuleV2Affected == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Is a child site</label>
            </div>

            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center">
              <Checkbox name="noUsers" value="setHasNoUsers" onChange={() => localNoUsers == 0 ? setLocalNoUsers(1) : setLocalNoUsers(0)} checked={localNoUsers == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">No users</label>
            </div>

            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center">
              <Checkbox name="localDeviceTag" value="setLocalDeviceTag" onChange={() => handleNoPortalName()} checked={localNoTag == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">No portal name</label>
            </div>
            <div className={classes.filterType2} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <label htmlFor="word" className="font-bold block mb-2">
                Portal site name includes the word:
              </label>
              <InputText id="word" keyfilter="alphanum" value={deviceTag} onChange={handleInputChange} />

            </div>

            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="localDeviceTag" value="setLocalDeviceTag" onChange={() => handleHasSchedules(1)} checked={localHasSchedule == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">{`Has permanent schedule(s)`}</label>
            </div>
            <div className="flex align-items-center">
              <Checkbox name="localDeviceTag" value="setLocalDeviceTag" onChange={() => handleHasSchedules(2)} checked={localHasSchedule == 2} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">{`Does not have permanent schedule(s)`}</label>
            </div>

            <Divider type="solid" style={{ padding: 0 }} />
            <div className="flex align-items-center" style={{ marginBottom: "10px" }}>
              <Checkbox name="localTempSch" value="setLocalTempSch" onChange={() => handleHasTempSchedules(1)} checked={localHasTempSchedule == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">{`Has temporary schedule(s)`}</label>
            </div>
            <div className="flex align-items-center">
              <Checkbox name="localTempSched" value="setLocalTempSched" onChange={() => handleHasTempSchedules(2)} checked={localHasTempSchedule == 2} />
              <label style={{ marginLeft: "5px" }} htmlFor="excludes" className="ml-2">{`Does not have temporary schedule(s)`}</label>
            </div>


            <Divider type="solid" style={{ padding: 0 }} />
            <div className={classes.buttonRow}>
              <Button  icon="pi pi-refresh" type="button" style={{ marginRight: "15px" }} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger' />
              <Button  icon="pi pi-check" type="button" label="Apply" onClick={HandleApplyFilters} />
            </div>
          </div>
        )}

        {showSorts && (
          <div className={classes.filterDropdown}>
            <div className="flex align-items-center">
              <Checkbox name="lvDisabled" value="setLocalDeviceTag" onChange={() => HandleOrderByCreated()} checked={localSCreated == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Date created</label>
            </div>
            <Divider type='solid' />
            <div className="flex align-items-center">
              <Checkbox name="lvEnabled" value="setLocalDeviceTag" onChange={() => HandleOrderByUserCount()} checked={localSUserCount == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">User count</label>
            </div>
            <Divider type='solid' />
            <div className="flex align-items-center">
              <Checkbox name="lvEnabled" value="setLocalDeviceTag" onChange={() => HandleOrderByFirmware()} checked={localSFirmware == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvEnabled" className="ml-2">Firmware</label>
            </div>
            <Divider type='solid' />
            <div>
              <Checkbox name="lvDisabled" value="setLocalDeviceTag" onChange={() => HandleOrderByName()} checked={localSName == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Site name</label>
            </div>
            <Divider type='solid' />
            <div>
              <Checkbox name="cameraCount" value="setLocalSCameraCount" onChange={() => HandleOrderByCameraCount()} checked={localSCameraCount == 1} />
              <label style={{ marginLeft: "5px" }} htmlFor="lvDisabled" className="ml-2">Camera count</label>
            </div>
            <Divider type='solid' />

            <div className={classes.filterType}>
              <div className="flex gap-4 mt-3">
                <RadioButton
                  style={{ marginRight: "5px" }}
                  inputId="asc"
                  name="sortOrder"
                  value="Ascending"
                  onChange={(e) => setLocalSortAsc(1)}
                  checked={localSortAsc == 1}
                />
                <label style={{ marginRight: "20px" }} htmlFor="asc" className="ml-2">Ascending</label>

                <RadioButton
                  style={{ marginRight: "5px" }}
                  inputId="desc"
                  name="sortOrder"
                  value="Descending"
                  onChange={(e) => setLocalSortAsc(0)}
                  checked={localSortAsc == 0}
                />
                <label htmlFor="desc" className="ml-2">Descending</label>
              </div>
            </div>
            <br />
            <div className={classes.buttonRow}>
              <Button  icon="pi pi-refresh" type="button" style={{ marginRight: "15px" }} label="Reset" onClick={HandleResetFilters} outlined severity='danger' />
              <Button  icon="pi pi-check" type="button" label="Sort" onClick={HandleApplyFilters} />
            </div>
          </div>
        )}
      </div>

      {hasFilters && <Button icon="pi pi-refresh" label='Clear filters' outlined severity='danger' style={{ fontSize: "12px", padding: 15 }} onClick={() => HandleResetFilters()} />}
    </>
  );
};

export default AllSitesSearchBar;